import React from 'react';
import { Col, Form, FormGroup, FormControl, ControlLabel, HelpBlock, Button } from 'react-bootstrap';
import NumberFormat from 'react-number-format';
import Scroll from 'react-scroll';
import rest from 'rest';

import { REST_API_URL, APP_PATH } from "../../Utils/Global";
import { cloneObject } from "../../Utils/Utils";

import Status from '../Helper/Status';

import AbstractEntity from './AbstractEntity';

/**
* Class TaxeFonciere
* TaxeFonciere view component
**/
class TaxeFonciere extends AbstractEntity {
  /**
  * props
  * mode : readonly/add/edit
  * path : rest api path for the object's type
  * objectPath : rest api path for the object
  * data.object : instance data
  **/

  /**
  * getClassName
  * Returns the class name as String (once bundled the class name changes)
  **/
  static getClassName() {
    return "TaxeFonciere";
  }

  /**
  * render
  * Rendering component function : display the view
  **/
  render() {

    if(this.state.object === undefined) {
        return null;
    }

    // Form status information
    const status = <Status parent={this} type={this.state.status.type} message={this.state.status.message} />;
    const historyBack = <Button bsStyle="link" onClick={this.props.modal ? this.props.closeModal : this.goBack} className="btnBack"><span className="glyphicon glyphicon-arrow-left" /> Retour</Button>;

    // Rendering the view
		return (
      <div>
        {/* Status information */}
        {status}
        {historyBack}
  			<Form ref="taxeFonciereForm" horizontal onSubmit={this.handleSubmit}>
          <HelpBlock>Formulaire de la taxe foncière.</HelpBlock>

          {/* Form content */}
          <FormGroup/>
          <FormGroup controlId="idTaxeFonciere" className="customHidden">
            <Col componentClass={ControlLabel} sm={5}>Identifiant</Col>
            <Col sm={1}><FormControl type="text" value={this.getObjectProperty("idTaxeFonciere")} disabled="true" /></Col>
          </FormGroup>

          <FormGroup controlId="annee">
            <Col componentClass={ControlLabel} sm={5}>Année</Col>
            <Col sm={2}><FormControl ref="annee" min={1980} max={2100} type="number" onChange={this.handleChange}
              value={this.getObjectProperty("annee") ? this.getObjectProperty("annee") : (new Date()).getFullYear()} /></Col>
          </FormGroup>

          <FormGroup controlId="valeur">
            <Col componentClass={ControlLabel} sm={5}>Valeur</Col>
            <Col sm={2}>
              <NumberFormat className="form-control" value={this.getObjectProperty("valeur")} onValueChange={this.handleValeurChange.bind(this)}
                decimalScale={2} thousandSeparator={" "} suffix={'€'} disabled={this.getReadOnly()} />
            </Col>
          </FormGroup>

          {/* Submit button */}
          {this.state.mode !== "readonly" ?
            <FormGroup>
              <Col smOffset={7} sm={1}>
                <Button bsStyle="success" onClick={this.submit.bind(this)}>Sauvegarder</Button>
              </Col>
            </FormGroup>: null
          }
        </Form>
      </div>
		);
	}

  /**
  * getIdField
  * Returns the object idField
  **/
  getIdField() {
    return "idTaxeFonciere";
  }

  /**
  * submit
  * Saves the data
  **/
  submit () {
    let method;
    const path = REST_API_URL + this.getObjectPath();

    if(this.state.mode === "edit") {
      method = "PUT";
    } else if (this.state.mode === "add") {
      method = "POST";
    }

    let taxeFonciereObj = cloneObject(this.state.object);
    if(!taxeFonciereObj.annee) {
      taxeFonciereObj.annee = (new Date()).getFullYear();
    }

    Scroll.animateScroll.scrollToTop({
      duration: 1000,
      delay: 100,
      smooth: true
    });

    rest({
      method: method,
      path: path,
      entity: JSON.stringify(taxeFonciereObj),
      headers: {
  			'Content-Type': 'application/json'
  		}
    }).then(response => {
      if(response.status.code === 200) {
        this.setState({
          status: {
            type: 'success',
            message: 'Taxe foncière sauvegardé.'
          },
          object: JSON.parse(response.entity)
        });
      } else if(response.status.code === 201) {
        const newObj = JSON.parse(response.entity);
        const state = {
          status: {
            type: 'success',
            message: 'Taxe foncière créé.'
          },
          mode: 'edit',
          object: newObj
        };

        this.replaceHistory(APP_PATH + "/taxefoncieres/" + newObj.idTaxeFonciere + "/edit", state);

        if(this.props.onAdd) {
          this.props.onAdd.call(this, newObj);
        }

      } else {
        this.setState({
          status: {
            type: 'danger',
            message: 'Erreur de sauvegarde.'
          }
        });
      }
  	}, response => {
      this.setState({
        status: {
          type: 'danger',
          message: 'Problème d\'appel au serveur.'
        }
      });
		});
  }

  /**
  * handleValeurChange
  * Handle valeur change
  **/
  handleValeurChange(values) {
    let objState = this.state;
    objState.object["valeur"] = values.value;
    this.setState(objState);
  }

}
export default TaxeFonciere;



// WEBPACK FOOTER //
// ./src/views/Entity/TaxeFonciere.js